export enum PeriodType {
  DAY = "day",
  WEEK = "week",
  MONTH = "month"
}

export interface LocationStatsHistoricalRequestDTO {
  organization_id: number;
  start_date: Date;
  end_date: Date;
  period: PeriodType;
}

export interface ScoreCount {
  score: string;
  count: number;
}

export interface DateScores {
  date: string;
  scores: ScoreCount[];
}

export interface LocationStatsHistoricalResponseDTO {
  organization_id: number;
  period: string;
  data: DateScores[];
}

export interface OrgHealthChartSettingData {
  label: string;
  fieldName: string;
  style: string;
  color: string;
}

export interface OrgHealthChartPoint {
  date: string;
  [key: string]: string | number;
}

export interface OrgHealthChartData {
  title: string;
  dataSourceSettings: OrgHealthChartSettingData[];
  data: OrgHealthChartPoint[];
}

export const transformToStackBarChartData = (
  response: LocationStatsHistoricalResponseDTO,
  title: string,
  dataSourceSettings: OrgHealthChartSettingData[]
): OrgHealthChartData => {
  const scoreMapping: { [key: string]: string } = {
    A1: "A",
    A2: "A",
    B1: "B",
    C1: "C",
    C2: "C",
    D1: "D"
  };

  const dataForLine = response.data.map((dateScore) => {
    const point: OrgHealthChartPoint = {
      date: dateScore.date
    };

    dataSourceSettings.forEach((setting) => {
      point[setting.fieldName] = 0;
    });

    // Initialize total field
    point["TOTAL"] = 0;

    dateScore.scores.forEach((score) => {
      const mappedScore = scoreMapping[score.score] || score.score.charAt(0);

      if (point[mappedScore] !== undefined) {
        point[mappedScore] = (point[mappedScore] as number) + score.count;
        // Add to total
        point["TOTAL"] = (point["TOTAL"] as number) + score.count;
      } else {
        console.warn(
          `Unknown score type: ${score.score}, mapped to ${mappedScore}`
        );
        point[mappedScore] = score.count;
        // Add to total
        point["TOTAL"] = (point["TOTAL"] as number) + score.count;
      }
    });

    return point;
  });

  return {
    title,
    dataSourceSettings,
    data: dataForLine
  };
};
